import styled from "@emotion/styled"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircle,
} from "@fortawesome/free-solid-svg-icons"
import {
  faFacebookSquare,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons"
import { get } from "lodash"
import React, { useContext } from "react"
import tw from "twin.macro"
import ThemeContext from "../context/theme-context"

library.add(
  faCircle,
  faFacebookSquare,
  faLinkedinIn,
  faYoutube,
)

const SocialLinksList = styled.ul`
  ${tw`flex flex-nowrap -ml-2`}
`
const SocialLinkItem = styled.li`
  ${tw`flex items-center pl-2 w-8 box-content`}
  a {
    transition: color 300ms ease-in-out;
    ${tw`text-white hover:text-blue`}
  }
`

const SocialLinks = ({ global }) => {
  const facebookUrl = get(global, "elements.facebook_url.value")
  const linkedinUrl = get(global, "elements.linkedin_url.value")
  const youtubeUrl = get(global, "elements.youtube_url.value")
  const { hydrated: isClient } = useContext(ThemeContext)

  return (
    <SocialLinksList>
      {linkedinUrl && (
        <SocialLinkItem>
          <a
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FontAwesomeIcon
              icon={["fab", "linkedin-in"]}
              mask={isClient ? ["fas", "circle"] : null}
              size="2x"
              transform="shrink-6"
            />
          </a>
        </SocialLinkItem>
      )}
      {facebookUrl && (
        <SocialLinkItem>
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FontAwesomeIcon
              icon={["fab", "facebook-square"]}
              mask={isClient ? ["fas", "circle"] : null}
              size="2x"
              transform="shrink-6"
            />
          </a>
        </SocialLinkItem>
      )}
      {youtubeUrl && (
        <SocialLinkItem>
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <FontAwesomeIcon
              icon={["fab", "youtube"]}
              mask={isClient ? ["fas", "circle"] : null}
              size="2x"
              transform="shrink-6"
            />
          </a>
        </SocialLinkItem>
      )}
    </SocialLinksList>
  )
}

export default SocialLinks
